import { useMemo } from 'react';
import Spacer from '@/common/components/spacer';
import TimeSm from '../../icons/time-sm';

export interface PickupDaysPillProps {
  pickupDays?: number;
}

export default function PickupDaysPill({ pickupDays }: PickupDaysPillProps) {
  const message = useMemo(() => {
    if (pickupDays === 1) {
      return 'Available tomorrow';
    }
    return 'Available today';
  }, [pickupDays]);

  return (
    <div className="flex items-center">
      <TimeSm />
      <Spacer variant="width4" />
      <p className={'body3-strong text-flexcar-green40'}>{message}</p>
    </div>
  );
}
